 <template>
    <div>
    <div class="allscreen"></div>
	<div class="dialog">
        <div class="dialog-block">
            <!-- <button class="close-btn" @click="closeWindow">&times;</button>-->

            <div class="language-section">
                <div class="language-buttons">
                    <button class="language-btn" @click="setlanguage('pl')" :class="{active: lang === 'pl' }">
                        <span><span class="language-flag">🇵🇱</span>{{ translation.polski }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('en')" :class="{active: lang === 'en' }">
                        <span><span class="language-flag">🇺🇸</span>{{ translation.angielski }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('es')" :class="{active: lang === 'es' }">
                        <span><span class="language-flag">🇪🇸</span>{{ translation.hiszpanski }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('de')" :class="{active: lang === 'de' }">
                        <span><span class="language-flag">🇩🇪</span>{{ translation.niemiecki }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('it')" :class="{active: lang === 'it' }">
                        <span><span class="language-flag">🇮🇹</span>{{ translation.wloski }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('fr')" :class="{active: lang === 'fr' }">
                        <span><span class="language-flag">🇫🇷</span>{{ translation.francuski }}</span>
                    </button>
                    <button class="language-btn" @click="setlanguage('pt')" :class="{active: lang === 'pt' }">
                        <span><span class="language-flag">🇵🇹</span>{{ translation.portugalski }}</span>
                    </button>
                </div>
            </div>

            <div class="theme-section">
                <div class="theme-buttons">
                    <button class="theme-btn" @click="changeTheme('light')" :class="{active: theme === 'light' }">
                        <span class="theme-icon">☀️</span>
                        {{ translation.jasny }}
                    </button>
                    <button class="theme-btn" @click="changeTheme('dark')" :class="{active: theme === 'dark' }">
                        <span class="theme-icon">🌙</span>
                        {{ translation.ciemny }}
                    </button>
                </div>
            </div>

            <button class="btn btn-green close-button" v-html="translation.zamknij" @click="closeWindow"></button>

        </div>
    </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';

export default {
    name: 'SettingsScreen',
    props: {
        language: String
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
    },
    methods: {
        closeWindow() {
            console.log('click button')
            //this.$emit('close-event-listener');
            //this.$parent.spinner = true;
            this.$parent.settings = false
            this.$parent.blured = false
            this.$parent.lang = this.lang
        },
        setlanguage(el) {
            localStorage.setItem('language', el)
            this.lang = el;
            this.$parent.lang = el;

            switch(this.lang)
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
        },
        changeTheme(el) {
            localStorage.setItem('theme', el)
            this.theme = el;
            this.$parent.mode = el
        }
    }
}
</script>

<style scoped>
.allscreen {
    position:fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index: 50;
}
.dialog {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc( 100% - 16vw );
    margin: 5vw;
    padding: 3vw;
    z-index: 200;
    border-radius:10px;
    background-color:var(--bs-gray-settings);
    -webkit-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    -moz-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
}
.dialog-block {
    width:95%;
}
.language-section {
    margin-bottom: 5px;
    /* margin-top:35px; */
}
.language-buttons {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.language-btn {
    background: var(--bs-settings-button-background);
    color: var(--bs-settings-button-color);
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.language-btn.active {
    background: var(--bs-settings-button-background-active);
    color: var(--bs-settings-button-color-active);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 -1px 2px rgba(0, 0, 0, 0.05);
    border: var(--bs-settings-button-border);
}
.language-flag {
    font-size: 18px;
    margin-right: 10px;
}
.theme-section {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    margin-bottom:20px;
}
.theme-buttons {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    gap: 2px;
}
.theme-btn {
    flex: 1;
    padding: 12px 16px;
    border: none;
    background: var(--bs-settings-button-background);;
    color: var(--bs-settings-button-color);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.theme-btn.active {
    background: var(--bs-settings-button-background-active);
    color: var(--bs-settings-button-color-active);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), inset 0 -1px 2px rgba(0, 0, 0, 0.05);
    border: var(--bs-settings-button-border);
}
.theme-icon {
    font-size: 16px;
}
.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 30px;
    color: var(--bs-settings-button-color);
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.btn-green {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight: bold;
    position: relative;

    font-size: 1em;
    font-family: 'Jost', sans-serif;

    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color: white;
    border: 0 none;
}



</style>
